/** Vision World Albertson — shared copy and links */

export const SITE = {
  businessName: 'Vision World Albertson',
  heroTitle: 'Vision World of Albertson',
  tagline: 'Discover your perfect pair of glasses with us!',
  address: {
    street: '888 Willis Ave',
    cityLine: 'Albertson, NY 11507',
    get full() {
      return `${this.street}, ${this.cityLine}`;
    },
  },
  phone: {
    display: '(516) 747-6363',
    tel: '+15167476363',
  },
  email: 'visionworldalbertsonny@gmail.com',
  /** Short link to open in Google Maps for directions */
  directionsUrl: 'https://maps.app.goo.gl/Q7c7u27aYodsmJqJ9',
};

/** Approximate store coordinates (matches prior map pin) */
export const STORE_COORDS = {
  lat: 40.76865,
  lng: -73.64779,
};

export const STORE_HOURS = [
  { day: 'Monday', hours: '9:30 AM – 6:00 PM' },
  { day: 'Tuesday', hours: '9:30 AM – 5:00 PM' },
  { day: 'Wednesday', hours: '9:30 AM – 7:00 PM' },
  { day: 'Thursday', hours: '9:30 AM – 5:00 PM' },
  { day: 'Friday', hours: '9:30 AM – 5:00 PM' },
  { day: 'Saturday', hours: '9:30 AM – 4:00 PM' },
  { day: 'Sunday', hours: null, closed: true },
];
